module.exports = __webpack_public_path__ + "img/cloth_g1_item_12.750df7e9.svg";